import React from 'react';
import { Box, Container } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import FadeIn from 'react-fade-in';
import { useTranslation } from 'react-i18next';
import Page from 'src/components/Page';
import AdministratorList from './AdministratorsList';
import AdministratorsToolbar from './AdministratorsToolbar';

const useStyles = makeStyles()(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const AdministratorsListView = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Page className={classes.root} title={t('ADMINISTRATORS_VIEW.TITLE')}>
      <FadeIn transitionDuration={200}>
        <Container maxWidth={false}>
          <AdministratorsToolbar />
          <Box mt={3}>
            <AdministratorList />
          </Box>
        </Container>
      </FadeIn>
    </Page>
  );
};

export default AdministratorsListView;
